import { Card } from "@/src/components/cards";
import { Patient, PatientDocument, Sample } from "@/src/data/allTypes";
import { getUserShortName } from "@/src/utils/utils";
import Barcode from "react-barcode";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import AnapathDocumentsCompartment from "./anapathDocumentsCompartment";
import openAnapathSampleActions, {
  addExamStep,
  addSampleDocument,
  addSampleUploads,
} from "./anapathSampleActions";
import AnapathStepsCompartment from "./anapathStepsCompartment";
import SliceCard from "./sliceCard";
import { Button } from "@/src/components/buttons";
import { UploadCards } from "@/src/components/uploadSpots";

export function AnapathSampleCard({
  sample,
  patient,
  onChange,
  onDocumentCreate,
  onDocumentValidate,
}: {
  sample: Sample;
  patient: Patient;
  onChange: (sample: Sample) => void;
  onDocumentCreate: (document: PatientDocument) => void;
  onDocumentValidate: (document: PatientDocument) => void;
}) {
  return (
    <Card
      key={sample.id}
      onClick={async () => {
        await openAnapathSampleActions({
          sample,
          patient,
          onChange,
          onDocumentCreate,
          onDocumentValidate,
        });
      }}
    >
      <div className="c1 gap20 mtop10" style={{ alignSelf: "start" }}>
        <div className="center">
          <Barcode
            value={sample.barcode || ""}
            displayValue={false}
            height={50}
            width={1}
            fontSize={12}
            margin={0}
          ></Barcode>
          <div className="bold f16 mtop5">{sample.barcode}</div>
        </div>

        <div>
          <div className="bold center capitalize">
            {sample.refAnswer?.reference?.name}{" "}
            {sample.location != null ? `- ${sample.location}` : ""}
          </div>
          <div className="black tcenter">
            <strong>{sample.numberOfPieces}</strong> flacon(s)
          </div>

          <div className="tcenter gray">
            Ajouté par {getUserShortName(sample.creator)}
          </div>
        </div>

        <FieldAnswersList
          reference={sample.refAnswer?.reference}
          patient={sample.patient}
          answers={sample.refAnswer?.fieldAnswers}
        />

        <div className="">{sample.refAnswer?.notes}</div>

        {sample.slices?.map((slice) => {
          if (!slice) return null;
          console.log(slice);
          return (
            <SliceCard
              key={slice.id}
              slice={slice}
              onChange={(slice) => onChange(sample)}
            />
          );
        })}

        <div className="c1 gap10">
          <div className="c1-auto acenter">
            <div className="bold">Etapes</div>
          </div>
          <AnapathStepsCompartment sample={sample} onChange={onChange} />
          <Button
            type="tertiary"
            onClick={async () => {
              await addExamStep({
                sample,
                onChange,
              });
            }}
          >
            +
          </Button>
        </div>

        <div className="c1 gap10">
          <div className="bold">Compte rendus</div>
          <AnapathDocumentsCompartment
            patient={patient}
            parent={sample}
            onCreate={onDocumentCreate}
            onValidate={onDocumentValidate}
          />
          <Button
            type="tertiary"
            onClick={async () => {
              await addSampleDocument({
                sample,
                patient,
                onDocumentCreate,
                onDocumentValidate,
                onChange,
              });
            }}
          >
            +
          </Button>
        </div>
        <div className="c1 gap10">
          <div className="bold">Fichiers</div>
          {!sample.uploads?.length && (
            <div className="gray center p20">Aucun élément trouvé</div>
          )}
          <UploadCards uploads={sample.uploads} count={3} />

          <Button
            type="tertiary"
            onClick={async () => {
              await addSampleUploads({
                sample,
                patient,
                onChange,
              });
            }}
          >
            +
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default AnapathSampleCard;
